import { render, staticRenderFns } from "./coach_message.vue?vue&type=template&id=2ba4ac98&scoped=true"
import script from "./coach_message.vue?vue&type=script&lang=js"
export * from "./coach_message.vue?vue&type=script&lang=js"
import style0 from "./coach_message.vue?vue&type=style&index=0&id=2ba4ac98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba4ac98",
  null
  
)

export default component.exports